// extracted by mini-css-extract-plugin
module.exports = {"topmessage":"Questionbody_topmessage__1BJHF","textbody":"Questionbody_textbody__2oWVl","classone":"Questionbody_classone__140_8","trigger":"Questionbody_trigger__2APwK"};